import * as React from 'react';
import { connect } from 'react-redux';
import MicroCategorieActions from './microCaterogieActions';
import * as agui from 'arm-gui/dist/controls';

import { AppConstants } from '../../constants/AppConstants';
import { i18n, Utils, NumberFormatter, isAuth, domainVal, DateFormatter, opt } from 'arm-common';
import ConfirmModalDeleteV4 from '../shared/confirmModalDeleteV4.jsx';
import GaranzieTable from '../garanzie/garanzieTable.jsx';
import ProdottoActions from '../prodotto/prodotto_actions';
import ProdottoTable from '../prodotto/prodottoTable.jsx';
import GaranzieActions from '../garanzie/garanzie_actions';
import BtnDelete from '../shared/BtnDelete.jsx'
import Rest from '../../webapi/Rest';
import AppActions from '../../app/app_actions'
import MicroCategoriaDocument from './MicroCategoriaDocument.jsx';
import ContraentiTable from './ContraentiTable.jsx'
import TipoPropostaTable from './TipoPropostaTable.jsx'
import ApplicationData from '../../app/aApplicationData'

class MicroCategorieDetails extends React.Component {
    constructor(props) {
        super(props);
        this.componentName = '[MicroCategorieDetails.jsx] ';
        this.modificaButton = this.modificaButton.bind(this);
        this.showConfirmPanel = this.showConfirmPanel.bind(this);
        this.inputChangeHandlerProdottoSearch = this.inputChangeHandlerProdottoSearch.bind(this);
        this.deleteGP = this.deleteGP.bind(this);
        this.searchProdottiOfGP = this.searchProdottiOfGP.bind(this);
        // this.questionarioPreviewButton = this.questionarioPreviewButton.bind(this);
        this.nuovaGaranziaButton = this.nuovaGaranziaButton.bind(this);
        this.downloadDocument = this.downloadDocument.bind(this);
        this.changeSelectedTab = this.changeSelectedTab.bind(this);
        this.state = {
            showConfirm: false
        }
    }

    componentDidMount() {
        console.log(this.componentName + 'componentDidMount');

        let idMicroCategorie = null;

        if (this.props.location.state && this.props.location.state.id) {
            // uso l'id che viene dallo stato
            idMicroCategorie = this.props.location.state.id;
        } else {
            // uso l'id che c'e' gia sullo store
            idMicroCategorie = this.props.microCategoria.id
        }
        console.log(this.componentName + '[ID] ' + idMicroCategorie);
        //faccio la chiamata REST per recuperare i dettagli 
        this.props.getMicroCategorieDetails(idMicroCategorie);

        let columns = [
            { field: 'id', title: 'Id', sortable: 'true' },
            { field: 'nome', title: i18n('ARM_CORE_PRODUCT.MANAGE.NOME', 'Nome'), sortable: 'true' },
            { field: 'nomeVersione', title: i18n('ARM_CORE_PRODUCT.SHARED.VERSIONE', 'Versione'), sortable: 'true' },
            { field: 'inizioValidita', title: i18n('ARM_CORE_PRODUCT.SHARED.INIZIO', 'Inizio'), sortable: 'true', formatter: this.dateFormatterShort },
            { field: 'fineValidita', title: i18n('ARM_CORE_PRODUCT.SHARED.FINE', 'Fine'), sortable: 'true', formatter: this.dateFormatterShort },
            // { field: 'numEmissioni', title: 'Emissioni', sortable: 'true' },
            { field: 'stato', title: i18n('ARM_CORE_PRODUCT.SHARED.STATO', 'Stato'), sortable: 'true', formatter: this.statoProdottoFormatter },
            { field: 'prodottoCmpPojo.compagnia.denominazione', title: i18n('ARM_CORE_PRODUCT.SHARED.COMPAGNIA', 'Compagnia'), sortable: 'true' },
            { field: 'info', title: i18n('ARM_CORE_PRODUCT.SHARED.INFO', 'Info'), formatter: this.columnDetail },
        ];

        $(this.refs.MyTable).bootstrapTable({
            columns: columns,
            idField: "id",
            sortable: true,
            search: true,
            showColumns: true,
            showExport: true,
            exportDataType: 'all',
            exportTypes: ['csv', 'excel'],
            onClickRow: (row, $element, field) => this.detailsOnClick(row, $element, field),
            sortOrder: "desc",
            pagination: true,
        });

        //effettuo la chimata rest per recuperare i dati
        this.props.getListProdotti(idMicroCategorie);
        //this.props.getListaGaranzie();
        this.props.getListaRamoSinistri();
    }

    componentWillReceiveProps(nextProps) {
        console.log(this.componentName + ' componentWillReceiveProps');

        if (nextProps.rows !== this.props.rows) {
            console.log("\t rows: " + (nextProps.rows !== null ? nextProps.rows.length : "NULL"));

            if (nextProps.rows === null) {
                $(this.refs.MyTable).bootstrapTable('removeAll');
            } else {
                $(this.refs.MyTable).bootstrapTable('load', nextProps.rows);
            }
        }
    }

    statoProdottoFormatter(value, row, index) {
        console.log(this.componentName + ' statoProdottoFormatter index: ' + index);

        if (value !== undefined && value !== null) {
            let title = ApplicationData.domainVal('AI_STATO_PRODOTTO', value, value).desDom;
            if (value === 'LAV') {  // lavorazzione
                return "<i class='fas fa-spinner' title='" + title + "'></i>";
            } else if (value === 'PUBB') {  // pubblicato
                return "<i class='far fa-check-circle' title='" + title + "'></i>";
            }
            return " ";
        }

        return '-';
    }

    searchProdottiOfGP() {
        console.log(this.componentName + ' searchProdottiOfGP');

        this.props.searchProdottiOfGP().then(
            resolve => {
                if (resolve === null) {
                    $(this.refs.MyTable).bootstrapTable('removeAll');
                } else {
                    $(this.refs.MyTable).bootstrapTable('load', resolve);
                }

            },
            reject => {
                console.log(this.componentName + ' searchProdottiOfGP KO');
            }
        )
    }

    // questionarioPreviewButton(e) {

    //     console.log(this.componentName + ' questionarioPreviewButton');

    //     let id = e.target.id;
    //     let idQst = null;
    //     if (id === "quotazione") {
    //         idQst = this.props.microCategoria.codQuestionarioQuotazione
    //     } else if (id = "emissione") {
    //         idQst = this.props.microCategoria.codQuestionarioEmissione
    //     } else {
    //         // non si puo trovare l'id
    //         return;
    //     }
    //     this.props.getQuestioanrioById(idQst).then(
    //         resolve => {
    //             this.props.history.push({ pathname: '/questionari/preview' });
    //         },
    //         reject => {
    //             console.log(this.componentName + ' QuestionarioActions.getQuestioanrioById(idQst) KO');
    //         }
    //     )

    // }

    changeSelectedTab(e) {
        if (e !== null && e !== undefined) {
            let idTab = e.target.id;
            this.props.changeSelectedTab(idTab);

        }
    }

    dateFormatterShort(value, row, index) {
        return DateFormatter.dataFormatterShort(value);
    }

    modificaButton() {

        console.log(this.componentName + ' modificaButton');
        this.props.history.push({
            pathname: '/microCategorie/create', state: {
                id: this.props.microCategoria.id,
                modifica: true
            }
        })
    }
    showConfirmPanel() {
        // $("#modalConfirm").modal("show");
        this.setState({ showConfirm: !this.state.showConfirm })
    }

    deleteGP() {
        console.log(this.componentName + ' deleteGP');
        this.setState({ showConfirm: false });

        this.props.deleteGP().then(

            resolve => {
                this.props.history.push({
                    pathname: '/microCategorie/list'
                });
            }, reject => {
                console.log(this.componentName + ' deleteGP KO');
                $('html, body').animate({ scrollTop: 0 }, 1000);
            }
        )
    }

    insertDateFormatter(value, row, index) {
        return DateFormatter.dataFormatter(row.insertDate);
    }

    columnDetail(value, row, index) {
        console.log("columnDetail:" + index);
        let temp;
        temp = "<button class='btn btn-info btn-sm'><i class='fas fa-info fa-fw'/></button>";
        return temp;
    }

    detailsOnClick(row, $element, field) {
        console.log(this.componentName + "detailsOnClick [field] " + field);

        this.props.history.push({ pathname: '/prodotto/details', state: { id: row.id } });
    }

    inputChangeHandlerProdottoSearch(e) {

        if (e !== null && e !== undefined) {
            let value = e.target.value;
            let id = e.target.id;
            console.log(this.componentName + "inputChangeHandlerProdottoSearch:" + id);
            this.props.inputChangeHandlerProdottoSearch(id, value);
        }
    }

    downloadDocument(documentId) {
        console.log(this.componentName + ' downloadDocument ');

        this.props.downloadDocument(documentId)
    }

    arrayBufferToBase64(buffer) {
        let binary = '';
        let bytes = new Uint8Array(buffer);
        let len = bytes.byteLength;
        for (let i = 0; i < len; i++) {
            binary += String.fromCharCode(bytes[i]);
        }
        return window.btoa(binary);
    }

    nuovaGaranziaButton() {
        console.log(this.componentName + "nuovaGaranziaButton:");

        this.props.inizializzaNuovaGaranziaDalGP().then(
            resolve => {
                this.props.history.push({ pathname: '/garanzie/create', state: { microCategorie: true } });
            },
            reject => {
                console.log(this.componentName + "nuovaGaranziaButton: KO");
            }
        )
    }
    render() {
        console.log(this.componentName + 'render');
        const ramoSinistro = this.props.ramoSinistri && this.props.ramoSinistri.filter(ramo => ramo.id === this.props.microCategoria.idRamoSinistri)[0];
        const denominazioneRamo = ramoSinistro && ramoSinistro.idConDenominazioneRamo;
        
        return (
            <div className="card">
                <div className="card-header">
                    <h3>{i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.DETTAGLIO_MICRO_CATEGORIA', 'Dettaglio di Micro-categoria')} {this.props.microCategoria.id}: {this.props.microCategoria && this.props.microCategoria.nome ? this.props.microCategoria.nome : null} </h3>
                </div>
                <div className="card-body">

                    <ul className="nav nav-tabs" id="myTab" role="tablist">
                        <li className={this.props.tabSelected === "home-tab" ? "active" : "nav-item"} >
                            <a className={this.props.tabSelected === "home-tab" ? "nav-link  active" : "nav-link "} onClick={this.changeSelectedTab} id="home-tab" data-toggle="tab" href="#home" role="tab" aria-controls="home" aria-selected="true">{i18n('ARM_CORE_PRODUCT.SHARED.DETTAGLI', 'Dettagli')}</a>
                        </li>
                        {isAuth('V2.ADMIN.PRODUCT.VIEW.GARANZIE') &&
                            <li className={this.props.tabSelected === "garanzie-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "garanzie-tab" ? "nav-link  active" : "nav-link "} onClick={this.changeSelectedTab} id="garanzie-tab" data-toggle="tab" href="#garanzie" role="tab" aria-controls="garanzie" aria-selected="true">{i18n('ARM_CORE_PRODUCT.MENUTOP.GARANZIE', 'Garanzie')}</a>
                            </li>
                        }
                        {isAuth('V2.ADMIN.PRODUCT.VIEW.PRODOTTI') &&
                            <li className={this.props.tabSelected === "prodotti-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "prodotti-tab" ? "nav-link  active" : "nav-link "} onClick={this.changeSelectedTab} id="prodotti-tab" data-toggle="tab" href="#prodotti" role="tab" aria-controls="prodotti" aria-selected="true">{i18n('ARM_CORE_PRODUCT.SHARED.PRODOTTI', 'Prodotti')}</a>
                            </li>}

                        <li className={this.props.tabSelected === "doc-tab" ? "active" : "nav-item"}>
                            <a className={this.props.tabSelected === "doc-tab" ? "nav-link  active" : "nav-link "} onClick={this.changeSelectedTab} id="doc-tab" data-toggle="tab" href="#doc" role="tab" aria-controls="doc" aria-selected="true" >{i18n('ARM_CORE_PRODUCT.SHARED.DOCUMENTI', 'Documenti')}</a>
                        </li>

                        <li className={this.props.tabSelected === "contraenti-tab" ? "active" : "nav-item"}>
                            <a className={this.props.tabSelected === "contraenti-tab" ? "nav-link  active" : "nav-link "} onClick={this.changeSelectedTab} id="contraenti-tab" data-toggle="tab" href="#contraenti" role="tab" aria-controls="contraenti" aria-selected="true" >{i18n('ARM_CORE_PRODUCT.SHARED.CONTRAENTI', 'Contraenti')}</a>
                        </li>
                        {isAuth('VIEW_TAB_MICROCATEGORIA_TIPO_PROPOSTA') && 
                            <li className={this.props.tabSelected === "tipoProposta-tab" ? "active" : "nav-item"}>
                                <a className={this.props.tabSelected === "tipoProposta-tab" ? "nav-link  active" : "nav-link "} onClick={this.changeSelectedTab} id="tipoProposta-tab" data-toggle="tab" href="#tipoProposta" role="tab" aria-controls="tipoProposta" aria-selected="true">{i18n('ARM_CORE_PRODUCT.SHARED.TIPO_PROPOSTA', 'Tipo proposta')}</a>
                            </li>
 }
                    </ul>
                    <div className="tab-content" id="myTabContent">
                        <div className={this.props.tabSelected === 'home-tab' ? 'tab-pane active' : 'tab-pane'} id="home" role="tabpanel" aria-labelledby="home-tab">
                            {this.props.microCategoria ?
                                <div>
                                    <dl className="row mt-4">
                                        <div className="col-12 col-sm-12 col-md-6 col-lg-6 ">
                                            {this.props.microCategoria.imagine ?
                                                <img style={{ paddingLeft: 0, paddingRight: 0, height: "150px", width: "400px", border: "2px solid  #dee2e6" }} className=" col-12 mt-2 ml-4" sizes="50x32" rel="icon" src={this.props.microCategoria.imagine ? "data:image/png;base64," +  this.props.microCategoria.imagine : ""} alt="Card image cap" />
                                                : this.props.microCategoria.imagePath ?
                                                     <img style={{ paddingLeft: 0, paddingRight: 0, height: "150px", width: "400px", border: "2px solid  #dee2e6" }} className=" col-12 mt-2 ml-4" sizes="50x32" rel="icon" src={this.props.microCategoria.imagePath ? Rest.createRestLink("document/download/" + this.props.microCategoria.imagePath) : ""} alt="Card image cap" />
                                                :  <h6 className="mt-2">{i18n('ARM_CORE_PRODUCT.IMAGGE.MICRO','Nessuna immagine legata a questa micro-categoria')}</h6>}
                                        </div>
                                        <dl className="col-12 col-sm-12 col-md-6 col-lg-6">
                                            <dl className="row mt-4">
                                                <dt className="col-sm-4 col-6">{i18n('ARM_CORE_PRODUCT.MANAGE.NOME', 'Nome')}</dt>
                                                <dd className="col-sm-6 col-6">{this.props.microCategoria.nome}</dd>
                                            </dl>
                                            <dl className="row">
                                                <dt className="col-sm-4 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.DESCRIZIONE', 'Descrizione')}</dt>
                                                <dd className="col-sm-6 col-6">{this.props.microCategoria.descrizione}</dd>
                                            </dl>
                                        </dl>
                                    </dl>
                                    <dl className="row">
                                        <dt className="col-sm-2 col-6"> {i18n('ARM_CORE_PRODUCT.SHARED.ID', 'Id')}</dt>
                                        <dd className="col-sm-4 col-6">{this.props.microCategoria.id}</dd>
                                        <dt className="col-sm-2 col-6"> {i18n('ARM_CORE_PRODUCT.SHARED.ORDINE', 'Ordine')}</dt>
                                        <dd className="col-sm-4 col-6">{this.props.microCategoria.ordVis}</dd>
                                    </dl>
                                    <dl className="row">
                                        <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.DATA_FINE_ADESIONE', 'Data Fine Adesione')}</dt>
                                        <dd className="col-sm-4 col-6">{DateFormatter.dataFormatterShort(this.props.microCategoria.dataFineAdesione)}</dd>
                                    </dl>
                                    <dl className="row">
                                        <dt className="col-sm-2 col-6 ">{i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.QUESTIONARIO_QUOTAZIONE', 'Questionario Quotazione')}</dt>
                                        <dd className="col-sm-4 col-6">{this.props.microCategoria.codQuestionarioQuotazione ? this.props.microCategoria.codQuestionarioQuotazione
                                            // <button type="button" id="quotazione" className="btn btn-link" onClick={this.questionarioPreviewButton}>{this.props.microCategoria.codQuestionarioQuotazione} </button> 
                                            : null}</dd>
                                        <dt className="col-sm-2 col-6 ">{i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.QUESTIONARIO_EMISSIONE', 'Questionario Emissione')}</dt>
                                        <dd className="col-sm-4 col-6">
                                            {this.props.microCategoria.codQuestionarioEmissione ? this.props.microCategoria.codQuestionarioEmissione
                                                // <button type="button" id="emissione" className="btn btn-link" onClick={this.questionarioPreviewButton}>{this.props.microCategoria.codQuestionarioEmissione} </button> 
                                                : null}</dd>
                                        {opt("APP", "FL_VIEW_SINISTRO", "false") === "true" ?
                                            <>
                                                <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.SINISTRI', 'Questionario Sinistro')}</dt>
                                                <dd className="col-sm-4 col-6">{this.props.microCategoria.codQuestionarioSinistro}</dd>
                                            </>
                                            : null}
                                    
                                      
                                    </dl>

                                    <dl className="row">
                                        <dt className="col-sm-2 col-6 ">{i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIE.QUESTIONARIO_ACCETTAZIONE', 'Questionario Accettazione')}</dt>
                                        <dd className="col-sm-4 col-6">
                                            {this.props.microCategoria.codQuestionarioAccettazione ? this.props.microCategoria.codQuestionarioAccettazione
                                                // <button type="button" id="emissione" className="btn btn-link" onClick={this.questionarioPreviewButton}>{this.props.microCategoria.codQuestionarioEmissione} </button> 
                                                : null}</dd>
                        

                                    
                                    </dl>
                                    <dl className="row">
                                        <dt className="col-sm-2 col-6"> {i18n('ARM_CORE_PRODUCT.SHARED.AMBITO', 'Ambito')}</dt>
                                        <dd className="col-sm-4 col-6">{(this.props.microCategoria.codAmbito !== null && this.props.microCategoria.codAmbito !== undefined) ? ApplicationData.domainVal('AI_AMBITO_RAMO', this.props.microCategoria.codAmbito, this.props.microCategoria.codAmbito).desDom : "-"}</dd>
                                        {/* <dt className="col-sm-2 col-6"> {i18n('ARM_CORE_PRODUCT.SHARED.REGOLA_VISIBILITA', 'Regola visibilità')}</dt>
                                        <dd className="col-sm-4 col-6">{(this.props.microCategoria.regolaVisibilita !== null && this.props.microCategoria.regolaVisibilita !== undefined) ? this.props.microCategoria.regolaVisibilita : "-"}</dd> */}
                                        {/* <dt className="col-sm-2 col-6"> {i18n('ARM_CORE_PRODUCT.PRODOTTO.MICRO_CATEGORIA_PACCHETTO', 'Microcategoria pacchetto')}</dt>
                                        <dd className="col-sm-4 col-6">{(this.props.microCategoria.microCategoriaPacchetto === true) ? "True" : "False"}</dd> */}
                                    </dl>

                                    {opt("APP", "FL_VIEW_MICROCATEGORIA_PACCHETTO", "false") === "true" ? 
                                     <dl className="row">
                                       <dt className="col-sm-2 col-6"> {i18n('ARM_CORE_PRODUCT.PRODOTTO.MICRO_CATEGORIA_PACCHETTO', 'Microcategoria pacchetto')}</dt>
                                       <dd className="col-sm-4 col-6">{(this.props.microCategoria.microCategoriaPacchetto === true) ? "True" : "False"}</dd>
                                 </dl>
                                    :null}

                                    <dl className="row">
                                        <dt className="col-sm-2 col-6"> {i18n('ARM_CORE_PRODUCT.SHARED.CATEGORIA_PRODOTTO', 'Categoria Prodotto')}</dt>
                                        <dd className="col-sm-4 col-6">{(this.props.microCategoria.categoriaProdotto && this.props.microCategoria.categoriaProdotto.nome) ? this.props.microCategoria.categoriaProdotto.nome : "-"}</dd>
                                        <dt className="col-sm-2 col-6"> {i18n('ARM_CORE_PRODUCT.SHARED.FAMIGLIA_PRODOTTO', 'Famiglia Prodotto')}</dt>
                                        <dd className="col-sm-4 col-6">{(this.props.microCategoria.famigliaProdotto && this.props.microCategoria.famigliaProdotto.nome) ? this.props.microCategoria.famigliaProdotto.nome : "-"}</dd>
                                    </dl>

                                    <dl className="row">
                                        <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.INSERITO_DA', 'Inserito da')} </dt>
                                        <dd className="col-sm-4 col-6">{this.props.microCategoria.insertUser}</dd>
                                        <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.DATA_INSERIMENTO', 'Data Inserimento')}</dt>
                                        <dd className="col-sm-4 col-6">{DateFormatter.dataFormatter(this.props.microCategoria.insertDate)}</dd>

                                    </dl>
                                    <dl className="row">
                                        <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.MODIFICATO_DA', 'Modificato da')}</dt>
                                        <dd className="col-sm-4 col-6">{this.props.microCategoria.updateUser}</dd>
                                        <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.DATA_MODIFICA', 'Data Modifica')}</dt>
                                        <dd className="col-sm-4 col-6">{DateFormatter.dataFormatter(this.props.microCategoria.updateDate)}</dd>

                                    </dl>
                                    {isAuth('V2.ADMIN.PRODUCT.VIEW.FL_FINANZIARIA') &&
                                        <dl className="row">
                                            <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.MICRO_CATEGORIA.FLAG_FINANZIARIA', 'Flag finanziaria')}</dt>
                                            <dd className="col-sm-4 col-6">{this.props.microCategoria.flFinanziaria ? i18n('ARM_CORE_PRODUCT.SHARED.SI', 'Si') :
                                                i18n('ARM_CORE_PRODUCT.SHARED.NO', 'No')}</dd>

                                        </dl>
                                    }
                                    {opt("APP", "FL_VIEW_TAB_RAMO", "false") === "true" &&
                                        <dl className="row">
                                            <dt className="col-sm-2 col-6">{i18n('ARM_CORE_PRODUCT.SHARED.RAMO_SINISTRI', 'Ramo')}</dt>
                                            <dd className="col-sm-4 col-6">{denominazioneRamo}</dd>
                                        </dl>
                                    }

                                </div>
                                :
                                null
                            }
                        </div>
                        <div className={this.props.tabSelected === 'prodotti-tab' ? 'tab-pane active' : 'tab-pane'} id="prodotti" role="tabpanel" aria-labelledby="prodotti-tab">
                            <div className="mt-5">
                                <div className="row">
                                    <div className="col col-sm-4 col-md-4 col-lg-4">
                                        <div className="form-group">
                                            <label htmlFor="dataValidita">  {i18n('ARM_CORE_PRODUCT.SHARED.DATA_VALIDITA', 'Data Validità')} </label>
                                            <input className="form-control" type="date"
                                                onChange={this.inputChangeHandlerProdottoSearch}
                                                value={this.props.psp.dataValidita ? DateFormatter.formatDateFromMilisToString(this.props.psp.dataValidita) : ""}
                                                id="dataValidita" name="dataValidita" />
                                        </div>
                                    </div>
                                    {/* <div
                                        style={{
                                            marginTop: 30,
                                            marginLeft: 15,
                                        }} >

                                        <agui.aButton className="float-right" bs='primary' onClick={this.searchProdottiOfGP} icon="fas fa-search" inline={true}>{i18n('ARM_CORE_PRODUCT.SHARED.CERCA', 'Cerca')} </agui.aButton>
                                    </div> */}
                                </div>
                            </div>
                            {this.props.microCategoria ?
                                <div>
                                    <table ref="MyTable" className={AppConstants.CLASS_TABLE} />
                                    {/* <ProdottoTable source="microCategorieDetails" rows={this.props.rows} history={this.props.history}></ProdottoTable> */}

                                </div>
                                : null}

                        </div>
                        <div className={this.props.tabSelected === 'garanzie-tab' ? 'tab-pane active' : 'tab-pane'} id="garanzie" role="tabpanel" aria-labelledby="garanzie-tab">
                            <div className="mt-3">
                                {/* <agui.aButton className="float-left" bs='primary' onClick={this.nuovaGaranziaButton} icon="fa fa-plus" inline={true}>Nuova</agui.aButton> */}
                                <GaranzieTable source="gpDetails" history={this.props.history} rows={this.props.microCategoria.listaGaranzie} ></GaranzieTable>
                            </div>
                        </div>
                        <div className={this.props.tabSelected === 'doc-tab' ? 'tab-pane active' : 'tab-pane'} id="doc" role="tabpanel" aria-labelledby="doc-tab">
                            <MicroCategoriaDocument
                                downloadDocument={this.downloadDocument} idMicroCategoria={this.props.microCategoria.id} rows={this.props.microCategoria.listDocumenti}
                                deleteMicroCategoriaDocument={this.props.deleteMicroCategoriaDocument}
                                modificaMicroCategoriaDocument={this.props.modificaMicroCategoriaDocument}
                                getListaDocumenti={this.props.getListaDocumenti} />

                        </div>

                        <div className={this.props.tabSelected === 'contraenti-tab' ? 'tab-pane active' : 'tab-pane'} id="contraenti" role="tabpanel" aria-labelledby="contraenti-tab">
                            <ContraentiTable contraenti={this.props.microCategoria.listContraenti} />
                        </div>
                        {isAuth('VIEW_TAB_MICROCATEGORIA_TIPO_PROPOSTA') &&
                        <div className={this.props.tabSelected === 'tipoProposta-tab' ? 'tab-pane active' : 'tab-pane'} id="tipoProposta" role="tabpanel" aria-labelledby="tipoProposta-tab">
                            <TipoPropostaTable tipoProposta={this.props.listTipoProposta} />
                        </div>
                        }
                    </div>

                </div>
                <div className="card-footer">
                    <div className="float-left">
                        {this.props.tabSelected !== "doc-tab" &&
                            this.props.tabSelected !== "prodotti-tab" && isAuth('V2.ADMIN.PRODUCT.EDIT') &&
                            <agui.aButton bs="primary" className="mr-3" icon="fas fa-edit" onClick={this.modificaButton}>{i18n('ARM_CORE_PRODUCT.SHARED.MODIFICA', 'Modifica')}</agui.aButton>
                        }
                        {isAuth('V2.ADMIN.PRODUCT.DELETE') &&
                            <BtnDelete onClick={this.showConfirmPanel} className="ml-2" ></BtnDelete>
                        }
                        {/* <agui.aButton bs="danger" icon="fas fa-trash-alt" onClick={this.showConfirmPanel} >Elimina</agui.aButton> */}
                    </div>
                    <agui.aButton bs="secondary" className="float-right mr-2" href="#/microCategorie/list" >{i18n('ARM_CORE_PRODUCT.SHARED.TORNA_ALLA_LISTA', 'Torna alla lista')}</agui.aButton>
                </div>
                <ConfirmModalDeleteV4
                    show={this.state.showConfirm}
                    deleteOnClick={this.deleteGP}
                    onClose={this.showConfirmPanel} />
            </div >
        );
    }
};




function mapStateToProps(state, ownProps) {
    return {
        microCategoria: state.microCategorie.detailsMC,
        rows: state.microCategorie.listProdotti,
        psp: state.prodotto.psp,
        tabSelected: state.microCategorie.tabSelected,
        ramoSinistri: state.microCategorie.ramoSinistri,
        listTipoProposta: state.microCategorie.detailsMC.listTipoProposta,
    }
}


function mapDispatchToProps(dispatch) {
    return {
        getMicroCategorieDetails(gpId) {
            return dispatch(MicroCategorieActions.getMicroCategorieDetails(gpId));
        },
        deleteGP() {
            return dispatch(MicroCategorieActions.deleteGP());
        },
        getListProdotti(id) {
            return dispatch(MicroCategorieActions.getListProdotti(id));
        },
        getListaGaranzie() {
            return dispatch(MicroCategorieActions.getListaGaranzie());
        },
        searchProdottiOfGP() {
            return dispatch(MicroCategorieActions.searchProdottiOfGP());
        },
        inputChangeHandlerProdottoSearch(id, value) {
            return dispatch(ProdottoActions.inputChangeHandlerProdottoSearch(id, value));
        },
        getQuestioanrioById(idQst) {
            return dispatch(QuestonarioActions.getQuestioanrioById(idQst))
        },
        inizializzaNuovaGaranziaDalGP() {
            return dispatch(GaranzieActions.inizializzaNuovaGaranziaDalGP())
        },
        downloadDocument(documentId) {
            return dispatch(AppActions.downloadDocument(documentId));
        },

        getListaDocumenti(idMicroCategoria) {
            return dispatch(MicroCategorieActions.getDocumentiMicroCategoria(idMicroCategoria));
        },
        deleteMicroCategoriaDocument(idDocument) {
            return dispatch(MicroCategorieActions.deleteMicroCategoriaDocument(idDocument));
        },

        changeSelectedTab(idTab) {
            return dispatch(MicroCategorieActions.changeSelectedTab(idTab));
        },

        getListaRamoSinistri() {
            return dispatch(MicroCategorieActions.getListaRamoSinistri());
        },

        modificaMicroCategoriaDocument(id, ordVis, oldOrdVis, idMicroCategoria) {
            return dispatch(MicroCategorieActions.modificaMicroCategoriaDocument(id, ordVis, oldOrdVis, idMicroCategoria))
        }
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(MicroCategorieDetails);
